module.exports = __webpack_public_path__ + "static/media/Snelweg.c11bbf14.mp3";